// extracted by mini-css-extract-plugin
module.exports = {"tokens":"\"../../style/tokens.module.css\"","redColor":"#FF6541","yellowColor":"#FFF460","pinkColor":"#FFB4CE","span":"pin_span__2Wuzw","title":"pin_title__2kRIr"};